import axios from "./axios";

class records {
  getRecords(data) {
    return axios.get("record_list/", { params: data });
  }

  details(data) {
    return axios.get("record_detail/", { params: data });
  }

  contactInfo(data) {
    return axios.get("record_detail/contact_info/", { params: data });
  }

  addContactInfo(data) {
    return axios.post("record_detail/contact_info/", data);
  }

  deleteContactInfo(data) {
    return axios.delete("record_detail/contact_info/", { data: data });
  }

  updateContactInfo(data) {
    return axios.put("record_detail/contact_info/", data);
  }

  getActivities(data) {
    return axios.get("logs/", { params: data });
  }

  getNotes(data) {
    return axios.get("extra_info/", { params: data });
  }

  addNotes(data) {
    return axios.post("extra_info/", data);
  }

  deleteNote(data) {
    return axios.delete("extra_info/", { data: data });
  }

  updateNote(data) {
    return axios.put("extra_info/", data);
  }
  getTags(data) {
    return axios.get("tags/", { params: data });
  }
  AddTags(data) {
    return axios.post("tags/", data);
  }
  getNewTags(data) {
    return axios.get(`crm_tag/${data}/`);
  }
  addNewTags(id, data) {
    return axios.patch(`crm_tag/${id}/`, data);
  }

  getTask(data) {
    return axios.get("task/", { params: data });
  }

  getFollowUpTask() {
    return axios.get("follow-up/");
  }

  addTask(data) {
    return axios.post("task/", data);
  }

  deleteTask(data) {
    return axios.delete("task/", { data: data });
  }

  updateTask(data) {
    return axios.put("task/", data);
  }

  getStatusSettings() {
    return axios.get("user_setting/");
  }

  updateStatusSettings(data) {
    return axios.post("user_setting/", data);
  }

  getUserProfile() {
    return axios.get("user/profile/");
  }

  getDashboardStats() {
    return axios.get("dash_board/statistics/");
  }

  getMarkets() {
    return axios.get("market/");
  }

  addMarket(data) {
    return axios.post("market/", data);
  }

  updateMarket(data) {
    return axios.put("market/", data);
  }

  deleteMarket(data) {
    return axios.delete("market/", { data: data });
  }

  getAddPerson() {
    return axios.get("add_person/");
  }

  addPerson(data) {
    return axios.post("add_person/", data);
  }

  getCrmTeam() {
    return axios.get("crm/team/");
  }

  searchEmail(data) {
    return axios.post("search_email/", data);
  }

  searchParticularTeam(data) {
    return axios.post("crm/team/", data);
  }

  getDashboardLeads(data) {
    return axios.get("crm/dash_board/", { params: data });
  }

  getCustomerCareLeads(data) {
    return axios.get("crm/customer_care/", { params: data });
  }

  getPendingFiles(data) {
    return axios.get("crm/pending_files/", { params: data });
  }

  getUserProfileCustomerCare(data) {
    return axios.get("user/profile/", { params: data });
  }

  unsubscribeOrder(data) {
    return axios.get("crm/cancel_order/", { params: data });
  }

  clearLowAppend(data) {
    return axios.get("crm/clear_low_appended_order/", { params: data });
  }

  getCatalogLookup(data) {
    return axios.get("crm/catalog_lookup/", { params: data });
  }

  addToCart(data) {
    return axios.post("crm/cart/", data);
  }

  getCartItems(data) {
    return axios.get("crm/cart/", { params: data });
  }

  removeCartItem(data) {
    return axios.delete("crm/cart/", { data: data });
  }

  updateCartItemPrice(data) {
    return axios.put("crm/cart/", data);
  }

  placeOrder(data) {
    return axios.post("crm/place_order/", data);
  }

  applyCoupon(data) {
    return axios.post("crm/apply_coupon/", data);
  }

  getStripePublicKey() {
    return axios.get("crm/stripe/get/public_key/");
  }

  getStripeSaveCards() {
    return axios.get("crm/stripe/cards/");
  }

  getSaveCardPM(data) {
    return axios.post("crm/stripe/cards/", data);
  }

  getAuthFilesUploaderSource(data) {
    return axios.get("crm/auth_order/uploadfile/", { params: data });
  }

  authFilesUploaderSource(data) {
    return axios.post("crm/auth_order/uploadfile/", data);
  }

  placeAuthOrder(data) {
    return axios.post("crm/auth_order/place_order/", data);
  }

  getJobStatistics(data) {
    return axios.get("crm/job_statistics/", { params: data });
  }

  getSearchHistory(data) {
    return axios.get("crm/search_history/", { params: data });
  }

  singleSkip(data) {
    return axios.post("crm/single_skip/", data);
  }

  singleSkipSearchId(data) {
    return axios.post("crm/single_skip/search_id/", data);
  }

  searchStatus(data) {
    return axios.post("crm/search_status/", data);
  }

  singleSkipPackages() {
    return axios.get("crm/single_skip/");
  }

  UpdateUserProfile(data) {
    return axios.put("user/profile/", data);
  }

  affiliateUsers(data) {
    return axios.get("crm/affiliate/users/", { params: data });
  }

  affiliateStatus(data) {
    return axios.get("crm/affiliate/tos/", { params: data });
  }

  affiliateTOS(data) {
    return axios.post("crm/affiliate/tos/", data);
  }

  UpdatePaypalEmail(data) {
    return axios.put("crm/affiliate/", data);
  }

  affiliateInfo(data) {
    return axios.get("crm/affiliate/", { params: data });
  }

  affiliateOrders(data) {
    return axios.post("crm/affiliate/users/", data);
  }

  affiliatePaymentsHistory(data) {
    return axios.get("crm/affiliate/payments/", { params: data });
  }

  addAffiliatePayment(data) {
    return axios.post("crm/affiliate/payments/", data);
  }

  updateAffiliatePayment(data) {
    return axios.put("crm/affiliate/payments/", data);
  }

  deleteAffiliatePayment(data) {
    return axios.delete("crm/affiliate/payments/", { data: data });
  }

  getSccz(data) {
    return axios.get("crm/get/sccz/", { params: data });
  }

  getSitus(data) {
    return axios.get("crm/list_creation/get_count/", { params: data });
  }
  getOptions(data) {
    return axios.get("crm/list_creation/get_options/", { params: data });
  }
  postSaveList(data) {
    return axios.post("crm/list_creation/saved_list/", data);
  }
  putSaveList(data) {
    return axios.put("crm/list_creation/saved_list/", data);
  }
  getSaveList() {
    return axios.get("crm/list_creation/saved_list/");
  }
  delSaveList(data) {
    return axios.delete("crm/list_creation/saved_list/", { data: data });
  }
  requestdata(data) {
    return axios.post("crm/list_creation/request_for_data/", data);
  }
  leadRequestData(data) {
    return axios.post("/crm/catalog_lookup/request_for_data/", data);
  }
  getLeadRequestData() {
    return axios.get("/crm/catalog_lookup/request_for_data/");
  }
  getLookupRecord(data) {
    return axios.get("/record/insert/", { params: data });
  }
  getLookupRecordDetail(data) {
    return axios.get("/record_detail/", { params: data });
  }
  transferCart(data) {
    return axios.post("crm/transfer/cart/", data);
  }
  addToUat(data) {
    return axios.post("/uat/insert_2/", data);
  }
  addToAddress(data) {
    return axios.post("/record/insert/", data);
  }
  getListName() {
    return axios.get("crm/list_creation/my_lists/");
  }
  postListName(data) {
    return axios.post("crm/list_creation/my_lists/", data);
  }
  patchListName(data) {
    return axios.patch("crm/list_creation/my_lists/", data);
  }
  deleteListName(data) {
    return axios.delete("crm/list_creation/my_lists/", { data: data });
  }
  getDelCount(data, tag) {
    if (tag) {
      return axios.get(`property_status/?pipeline=${data}&tag_name=${tag}`);
    } else {
      return axios.get(`property_status/?pipeline=${data}`);
    }
  }
  postListConnection(data) {
    return axios.post("crm/list_creation/my_lists/add/", data);
  }
  uploadFile(data) {
    return axios.post("crm/list_creation/import_list/", data);
  }
  getPackage() {
    return axios.get("crm/alm/");
  }
  getAgents() {
    return axios.get("chatbot/bots/");
  }
  getScripts() {
    return axios.get("chatbot/scripts/");
  }
  getKnowledgebase() {
    return axios.get("chatbot/knowledgebase/");
  }
  getBotType() {
    return axios.get("chatbot/bots/type/");
  }
  getPrompts() {
    return axios.get("chatbot/prompts/");
  }
  postChatbot(data) {
    return axios.post("chatbot/bots/", data);
  }
  putChatbot(data) {
    return axios.put("chatbot/bots/", data);
  }
  postScripts(data) {
    return axios.post("chatbot/scripts/", data);
  }
  putScripts(data) {
    return axios.put("chatbot/scripts/", data);
  }
  delScripts(data) {
    return axios.delete("chatbot/scripts/", {data:data});
  }
  postKnowledgeBase(data) {
    return axios.post("chatbot/knowledgebase/", data);
  }
  putKnowledgeBase(data) {
    return axios.put("chatbot/knowledgebase/", data);
  }
  delKnowledgeBase(data) {
    return axios.delete("chatbot/knowledgebase/", {data:data});
  }
  postPrompt(data) {
    return axios.post("chatbot/prompts/", data);
  }
  putPrompt(data) {
    return axios.put("chatbot/prompts/", data);
  }
  delPrompt(data) {
    return axios.delete("chatbot/prompts/", {data:data});
  }
  getEndUser() {
    return axios.get("chatbot/end_user/chats/");
  }
  getMessages(data) {
    return axios.get("chatbot/end_user/chat/messages/", { params: data });
  }
  getWidget(data) {
    return axios.get("chatbot/bots/widget/", { params: data });
  }
}

export default new records();
